// Compact count summary for form panels (audience list, import result): one
// bordered strip of label/value cells divided by hairlines, instead of
// dashboard StatCards. The first cell is the headline figure; a zero in any
// other cell is muted so the eye lands on what needs attention.
import React from 'react';

export interface CountStripItem {
  label: string;
  value: number;
  /** Optional one-line note under the value. */
  hint?: string;
}

interface CountStripProps {
  items: CountStripItem[];
  /** Accessible name for the group, e.g. "Audience counts". */
  label: string;
}

const COLS: Record<number, string> = {
  4: 'grid-cols-2 sm:grid-cols-4',
  5: 'grid-cols-2 sm:grid-cols-3 xl:grid-cols-5',
};

export default function CountStrip({ items, label }: CountStripProps) {
  return (
    <dl
      aria-label={label}
      className={`grid gap-px overflow-hidden rounded-lg border border-gray-700 bg-gray-700 ${COLS[items.length] ?? 'grid-cols-2 sm:grid-cols-4'}`}
    >
      {items.map((item, i) => {
        const headline = i === 0;
        const muted = !headline && item.value === 0;
        return (
          <div key={item.label} className="bg-gray-900 px-4 py-3">
            <dt className="text-xs font-medium text-gray-400">{item.label}</dt>
            <dd
              className={`mt-1 tabular-nums ${headline ? 'text-2xl font-semibold text-white' : 'text-xl font-medium'} ${
                muted ? 'text-gray-500' : headline ? '' : 'text-gray-100'
              }`}
            >
              {item.value.toLocaleString('en-AU')}
            </dd>
            {item.hint && <dd className="mt-0.5 text-xs text-gray-500">{item.hint}</dd>}
          </div>
        );
      })}
    </dl>
  );
}
